<template>
    <fragment>
        <c-generic-section>
            <div class="container-xs">
                <h1 class="mt-0 mb-16">Air Cargo Tracking</h1>
                <p class="mt-0 mb-8">Enter your tracking numbers to see the latest scan events for each shipment, from uplift in China to delivery in Australia.</p>
                <p class="tk-zh">空运单号即时查询,一号线/快件/澳邮单号均可。</p>
                <c-tracking-search class="tk-search" />
            </div>
        </c-generic-section>
        <c-cta top-divider bottom-divider split />
    </fragment>
</template>

<script>
// import layout
import CLayout from '@/layouts/LayoutDefault.vue'
// import sections
import CGenericSection from '@/components/sections/GenericSection.vue'
import CTrackingSearch from '@/components/sections/TrackingSearch.vue'
import CCta from '@/components/sections/Cta.vue'

export default {
  name: 'Tracking',
  components: {
    CGenericSection,
    CTrackingSearch,
    CCta
  },
  created() {
    this.$emit('update:layout', CLayout)
    document.title = 'Air Cargo Tracking — Line-1 Logistics'
  }
}
</script>

<style scoped>
.tk-zh {
    font-size: 13px;
    opacity: .7;
    margin: 0;
}
.tk-search {
    margin-top: 24px;
}
</style>
